import * as types from "./types";

const mutations = {
    [types.LOADING_DOCUMENT](state, value) {
        state.docLoader = value;
    },
    [types.GET_DOCUMENT_LIST](state, documents) {
        state.documents = documents;
    },
    [types.REMOVE_DOCUMENT](state, id) {        
        state.documents = state.documents.filter((x) => x.id !== id);        
    },
      [types.FILE_SHARING](state, file) {
        state.file = file;
    }
};

export default mutations;